export default class SubMenus
{
	constructor()
	{
		// Get all submenu toggles
		this._menu = document.querySelector('.jsMainMenu');
		this._subMenuToggles = document.querySelectorAll(".jsSubMenuToggle");

		// If there are any, initialize
		if (this._subMenuToggles.length > 0) this.init();
	}

	showNav(t)
	{
		// const menu = t.nextElementSibling;
		t.parentElement.classList.add("-shown");
	}

	hideNav(t)
	{
		// const menu = t.nextElementSibling;
		t.parentElement.classList.remove("-shown");
	}

	hideAll()
	{
		this._subMenuToggles.forEach( (el) =>
		{
			this.hideNav(el);
		} );
	}

	init()
	{
		let l = this._subMenuToggles.length;
		for (let i = 0; i < l; i++)
		{
			let t = this._subMenuToggles[i];
			t.addEventListener("click", () =>
			{
				if (t.parentElement.classList.contains('-shown'))
				{
					this.hideNav(t);
				}
				else
				{
					// Close any open submenus
					this._subMenuToggles.forEach(el =>
					{
						el.parentElement.classList.contains('-shown') ? this.hideNav(el) : null;
					});
					// Open clicked submenu
					this.showNav(t);
				}
			});

		}

		// Close all open menus when clicking outside their parent <ul>
		document.addEventListener( 'click', (e) =>
		{
			if (!this._menu.contains(e.target))
			{
				this.hideAll();
			}
		});

	}
}
